<template>
  <div>
    <v-dialog
      v-model="summaryDialog"
      max-width="600px"
      @click:outside="closeDialog"
    >
      <template v-slot:activator="{ on, attrs }">
        <p
          id="employeeSummaryID"
          v-bind="attrs"
          v-on="on"
          @click="openDialog"
        ></p>
      </template>
      <v-card
        style="padding: 10px 20px 20px 20px; position: relative"
        class="text-center"
      >
        <v-row v-if="!isLoading">
          <v-col md="12" style="padding: 0">
            <v-card-title>
              <v-spacer> </v-spacer> REKAPAN PRESENSI & LEMBUR
              <v-spacer> </v-spacer>

              <v-btn
                small
                icon
                color="red"
                style="color: white; position: absolute; top: 5px; right: 5px"
                @click="closeDialog"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text style="margin-top: 10px">
              <v-row no-gutters>
                <v-col cols="6" style="padding: 0">
                  <div style="padding: 0">
                    <v-col cols="4" style="padding: 0; text-align: left">
                      <p style="margin: 0; font-size: 12px">NAMA</p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        outlined
                        dense
                        readonly
                        :value="
                          detailEmployee != null ? detailEmployee.name : ''
                        "
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="6" style="padding: 0">
                  <div style="padding: 0 10px">
                    <v-col cols="4" style="padding: 0; text-align: left">
                      <p style="margin: 0; font-size: 12px">NIK</p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <v-text-field
                        outlined
                        dense
                        readonly
                        :value="
                          detailEmployee != null ? detailEmployee.nik : ''
                        "
                      />
                    </v-col>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters @click="openAttendanceDialog">
                    <v-col cols="4" class="d-flex justify-start align-center">
                      <p :style="`padding: 0; margin: 0 5px 0 0;`">HADIR</p>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ attrs, on }">
                          <div v-bind="attrs" v-on="on">
                            <v-icon
                              color="info"
                              x-small
                              style="
                                cursor: pointer;
                                position: realative;
                                top: -1px;
                                right: 1px;
                              "
                              >mdi-information-outline</v-icon
                            >
                          </div>
                        </template>
                        <span style="width: 250px">
                          Lihat daftar presensi
                        </span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-start align-center">
                      <p :style="`margin-left: auto; padding: 0; margin: 0;`">
                        :
                      </p>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        readonly
                        dense
                        :value="summary.hadir"
                        style="height: 40px"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="4" class="d-flex justify-start align-center">
                      <p :style="`padding: 0; margin: 0;`">TELAT</p>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-start align-center">
                      <p :style="`margin-left: auto; padding: 0; margin: 0;`">
                        :
                      </p>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        readonly
                        dense
                        :value="convertMinutes(summary.telat)"
                        style="height: 40px"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col cols="4" class="d-flex justify-start align-center">
                      <p :style="`padding: 0; margin: 0;`">ALPHA</p>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-start align-center">
                      <p :style="`margin-left: auto; padding: 0; margin: 0;`">
                        :
                      </p>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        readonly
                        dense
                        :value="summary.alpha"
                        style="height: 40px"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters @click="openLeaveDialog">
                    <v-col cols="4" class="d-flex justify-start align-center">
                      <p :style="`padding: 0; margin: 0 5px 0 0;`">CUTI</p>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ attrs, on }">
                          <div v-bind="attrs" v-on="on">
                            <v-icon
                              color="info"
                              x-small
                              style="
                                cursor: pointer;
                                position: realative;
                                top: -1px;
                                right: 1px;
                              "
                              >mdi-information-outline</v-icon
                            >
                          </div>
                        </template>
                        <span style="width: 250px">
                          Lihat daftar pengajuan cuti
                        </span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-start align-center">
                      <p :style="`margin-left: auto; padding: 0; margin: 0;`">
                        :
                      </p>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        readonly
                        dense
                        :value="summary.cuti"
                        style="height: 40px"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters @click="openPermissionDialog">
                    <v-col cols="4" class="d-flex justify-start align-center">
                      <p :style="`padding: 0; margin: 0 5px 0 0;`">IZIN</p>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ attrs, on }">
                          <div v-bind="attrs" v-on="on">
                            <v-icon
                              color="info"
                              x-small
                              style="
                                cursor: pointer;
                                position: realative;
                                top: -1px;
                                right: 1px;
                              "
                              >mdi-information-outline</v-icon
                            >
                          </div>
                        </template>
                        <span style="width: 250px">
                          Lihat daftar pengajuan izin
                        </span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-start align-center">
                      <p :style="`margin-left: auto; padding: 0; margin: 0;`">
                        :
                      </p>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        readonly
                        dense
                        :value="summary.izin"
                        style="height: 40px"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters @click="openOvertimeListDialog">
                    <v-col
                      cols="4"
                      class="d-flex justify-start align-center text-left"
                    >
                      <p :style="`padding: 0; margin: 0 5px 0 0;`">
                        JUMLAH LEMBUR
                      </p>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ attrs, on }">
                          <div v-bind="attrs" v-on="on">
                            <v-icon
                              color="info"
                              x-small
                              style="
                                cursor: pointer;
                                position: realative;
                                top: -1px;
                                right: 1px;
                              "
                              >mdi-information-outline</v-icon
                            >
                          </div>
                        </template>
                        <span style="width: 250px">
                          Lihat daftar pengajuan lembur
                        </span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-start align-center">
                      <p :style="`margin-left: auto; padding: 0; margin: 0;`">
                        :
                      </p>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        readonly
                        dense
                        :value="summary.frequency_overtime"
                        style="height: 40px"
                      />
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-row no-gutters>
                    <v-col
                      cols="4"
                      class="d-flex justify-start align-center text-left"
                    >
                      <p :style="`padding: 0; margin: 0;`">
                        TOTAL WAKTU LEMBUR
                      </p>
                    </v-col>
                    <v-col cols="1" class="d-flex justify-start align-center">
                      <p :style="`margin-left: auto; padding: 0; margin: 0;`">
                        :
                      </p>
                    </v-col>
                    <v-col cols="5">
                      <v-text-field
                        readonly
                        dense
                        :value="summary.total_overtime"
                        style="height: 40px"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-col>
        </v-row>
        <v-progress-circular
          v-else
          :size="50"
          :width="10"
          color="blue"
          indeterminate
          >Loading...</v-progress-circular
        >
      </v-card>
    </v-dialog>

    <overtime-dialog :overtimeSummary="overtimeSummary" />
    <attendance-dialog :attendanceData="attendanceList" />
    <leave-dialog :filteredLeave="filteredLeaveList" />
    <permission-dialog :filteredPermission="filteredPermissionList" />
  </div>
</template>

<script>
import axios from 'axios'
import buildType from '../../../../services/buildType'
export default {
  name: 'EmployeeSummary',
  props: [
    'detailEmployee',
    'attendanceSummary',
    'overtimeSummary',
    'leaveData',
    'permissionData',
    'employeeId',
    'companyId',
    'startDate',
    'endDate'
  ],
  components: {
    OvertimeDialog: () => import('./OvertimeDialog'),
    AttendanceDialog: () => import('./AttendanceDialog'),
    LeaveDialog: () => import('./LeaveDialog'),
    PermissionDialog: () => import('./PermissionDialog')
  },
  data() {
    return {
      hrsApi: buildType.apiURL('hrs'),
      attendance: buildType.apiURL('attendanceTrial'),
      summaryDialog: false,
      isLoading: false,
      summary: {
        hadir: 0,
        alpha: 0,
        cuti: 0,
        izin: 0,
        telat: 0,
        frequency_overtime: 0,
        total_overtime: 0
      },
      attendanceList: [],
      filteredLeaveList: [],
      filteredPermissionList: []
    }
  },
  methods: {
    openDialog() {
      //   console.log('this.detailEmployee', this.detailEmployee)
      console.log('this.attendanceSummary', this.attendanceSummary)
      // console.log('this.overtimeSummary', this.overtimeSummary)
      if (this.attendanceSummary && this.attendanceSummary.length > 0) {
        this.summary.hadir =
          this.attendanceSummary.find(
            (item) => item.attendance_status === 'normal'
          )?.frequency || 0
        this.summary.alpha =
          this.attendanceSummary.find(
            (item) => item.attendance_status === 'alpha'
          )?.frequency || 0
        this.summary.cuti =
          this.attendanceSummary.find(
            (item) => item.attendance_status === 'is_leave'
          )?.frequency || 0
        this.summary.izin =
          this.attendanceSummary.find(
            (item) => item.attendance_status === 'is_permit'
          )?.frequency || 0
        this.summary.telat =
          this.attendanceSummary.find(
            (item) => item.attendance_status === 'late'
          )?.total_late_minutes || 0
        const isLate = this.attendanceSummary.find(
          (item) => item.attendance_status === 'late'
        )
        if (isLate != undefined) {
          this.summary.hadir = this.summary.hadir + isLate?.frequency || 0
        }
        //   this.summary.frequency_overtime = this.attendanceSummary.find(
        //     (item) => item.attendance_status === 'overtime'
        //   )?.frequency || 0
        //   this.summary.total_overtime = this.attendanceSummary.find(
        //     (item) => item.attendance_status === 'overtime'
        //   )?.total_overtime || 0
      }
      if (this.overtimeSummary && this.overtimeSummary.length > 0) {
        this.summary.frequency_overtime = this.overtimeSummary.length
        const totalHour = this.getTotalHourInHourMinuteFormat(
          this.overtimeSummary
        )
        console.log('totalHour', totalHour)

        this.summary.total_overtime = totalHour.formatted
      }
      if (this.leaveData && this.leaveData.length > 0) {
        let count = 0
        const newArr = []
        for (let i = 0; i < this.leaveData.length; i++) {
          if (
            this.leaveData[i].status_leave == 1 ||
            this.leaveData[i].status_leave == 2 ||
            this.leaveData[i].status_leave == 3
          ) {
            if (this.leaveData[i].status_leave == 3) {
              // count++
              count = count + this.leaveData[i].total_requested_leave
            }
            newArr.push(this.leaveData[i])
          }
        }
        this.summary.cuti = count
        console.log('cuti newArr', newArr)

        this.filteredLeaveList = newArr
      }
      if (this.permissionData && this.permissionData.length > 0) {
        let count = 0
        const newArr = []
        for (let i = 0; i < this.permissionData.length; i++) {
          if (
            this.permissionData[i].status_permission == 1 ||
            this.permissionData[i].status_permission == 2
          ) {
            if (this.permissionData[i].status_permission == 2) {
              count++
            }
            newArr.push(this.permissionData[i])
          }
        }
        this.summary.izin = count
        console.log('izin newArr', newArr)

        this.filteredPermissionList = newArr
      }
      //   setTimeout(() => {
      //     this.summaryDialog = true
      //   }, 200)
    },
    closeDialog() {
      this.summaryDialog = false
    },
    openOvertimeListDialog() {
      // console.log(this.overtimeSummary)
      setTimeout(() => {
        document.getElementById('overtimeSummaryDialog').click()
      }, 200)
    },
    openAttendanceDialog() {
      const url = `${this.attendance}report/attendance/detail?keyword=${this.detailEmployee.nik}&offset=0&limit=1000&order_by=date&order_type=ASC&start_date=${this.startDate}&end_date=${this.endDate}`
      axios
        .get(url)
        .then((res) => {
          // console.log('list overtime >>>>', res)
          if (res.data.status_code === '00') {
            this.attendanceList = res.data.data
            console.log('attendance', res.data.data)
            setTimeout(() => {
              document.getElementById('attendanceDialog').click()
            }, 200)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    openLeaveDialog() {
      console.log(this.filteredLeaveList)

      setTimeout(() => {
        document.getElementById('leaveDialog').click()
      }, 200)
    },
    openPermissionDialog() {
      console.log(this.filteredPermissionList)

      setTimeout(() => {
        document.getElementById('permissionDialog').click()
      }, 200)
    },
    getTotalHourInHourMinuteFormat(arrayHour) {
      const total = arrayHour.reduce((sum, item) => {
        return sum + parseFloat(item.total_hour_rounding)
      }, 0)

      const hours = Math.floor(total)
      const minutes = Math.round((total - hours) * 60)

      return { hours, minutes, formatted: `${hours} jam ${minutes} menit` }
    },
    convertMinutes(mins) {
      const hours = Math.floor(mins / 60)
      const remainingMinutes = mins % 60
      const minutes = Math.floor(remainingMinutes)
      const seconds = Math.round((remainingMinutes - minutes) * 60)
      return `${hours} jam ${minutes} menit ${seconds} detik`
    },
    infoLabel(status) {
      const labels = {
        alpha: 'Alpha',
        late: 'Terlambat',
        normal: 'Hadir',
        off: 'Libur',
        is_permit: 'Izin',
        is_leave: 'Cuti'
      }
      return labels[status] || status
    },
    convertedDecimal(xData) {
      let val = ''
      if (xData !== null) {
        if (xData !== undefined) {
          if (`${xData}`.length < 4) {
            val = xData
          } else {
            val = xData.toFixed(2)
          }
        }
      }
      return val + ' menit'
    }
  }
}
</script>

<style></style>
